import type { CompareCellValue, SanityCompareView } from "./compare.type";

type CompareCellFromQuery = SanityCompareView["rows"][number]["cells"][number];

export function cellToIconValue(
  cell: CompareCellFromQuery | undefined
): CompareCellValue {
  const display = cell?.display ?? "included";
  if (display === "text") {
    return cell?.text?.trim() || "—";
  }
  return display === "included";
}
